//import {environment} from 'src/environments/environment';

import { Envsetting } from "../../../environments/environment";
import { OrganizationTypeComponent } from "../../core/components/admin/master/organization-type/organization-type.component";

export const API_URL: string = Envsetting.api_url;






export enum ApiMethod {
  GET = "GET",
  POST = "POST",
  PUT = "PUT",
  DELETE = "DELETE",
  PATCH = "PATCH"
}


export const API_ENDPOINTS = {
  addExhibitionRegistrationForm: 'eoiexhibition/addexhibitionregistrationform',
  addExhibitionRegistrationDownloadForm: 'eoiexhibition/downloadexhibitionregistrationform',

  MSME: {
    LOGIN: 'msme/login',
    CHANGEPASSWORD: 'msme/password/change',
    /*FORGOTPASSWORD: 'msme/password/update',*/
    GETALLUSERS: 'msme/getallusers',
    GETUSERBYUDYAMNO: 'msme/getuserbyudyamno',
    VALIDATEUSER: 'msme/validateuser',
    EOIVALIDATEUSER: 'msme/eoivalidateuser',
    SAVEUSER: 'msme/savemsmeuser',
    GETMSMEDetails: 'msme/ getlist',
    GETMSMEIndividualDetails: 'msme/ getdetails',
    POSTMSMEUpdate: 'msme/ user / msmestatus',
    GETMSMEPROFILEQUESTIONS: 'msme/getmsmeprofilequestions',
    GETORGANIZATIONTYPE: 'msme/getorganizationtype',
    GETSOCIALCATEGORY: 'msme/getsocialcategorymaster',
    GETENTERPRISETYPE: 'msme/getenterprisetypemaster',
    UPLOADFILE: 'msme/uploadfile',
    GETOTHERDETAILS: 'msme/getotherdetails',
    GETOTHERDETAILSFORMSSIDC: 'msme/getotherdetailsformssidc',
    SAVEMSMEQUESTIONANSWE: 'msme/savemsmequestionanswer',
    GETEVENTLIST: 'msme/geteventlistbymsmeid',
    GETEVENTFORENROLLMENT: 'msme/geteventdetailsforenrollment',
    SAVEMSMEPARTICIPANTLIST: 'msme/savemsmeparticipantsdetails',
    GETENROLLEDPARTICIPANTLIST: 'msme/getenrolledparticipantslist',

    GETEVENTFORDOWNLOAD: 'msme/geteventdetailsfordownload',
    GETEVENTCOUNTS: 'msme/geteventcounts',
    UPDATEENROLLEDPARTICIPANT: 'msme/updateenrolledparticipant',
    DELETEENROLLEDPARTICIPANT: 'msme/deleteenrolledparticipant',
    EMAILTICKETPDF: 'msme/emailticketpdf',
    GETMSMEEVENTDATES: 'msme/getmsmeeventdates',
    GETMSMEEVENTDATEWISEFORCALENDAR: 'msme/getmsmeeventdatewiseforcalendar',
    CHECKPARTICIPANTENROLLMENTCOUNT: 'MSME/checkparticipantenrollmentcount',
    MSMEALLCHECKSFOREVENTENROLLMENT: 'msme/msmeallchecksforeventenrollment',
    GETENROLLEDPARTICIPANTSCOUNT: 'msme/getenrolledparticipantscount',
    UPDATEUDYAMPROFILE: 'msme/updateudyamprofile',
    //MSMESUBMITGRIEVANCE: 'msme/msmesubmitgrievance',
    //GETSUBMITTEDMSMEGRIEVANCEDETAILS: 'msme/getmsmegrievancesubmiteddetails',
    //GETGRIEVANCEREPLY: 'msme/getgrievancedetailsreplyformsme',
    GETMSMEDASHBOARDCOUNTS: 'msme/getmsmedashboardcounts',
    GETMSMECONTACTDETAILS: 'msme/sendotp',
    //GETGRIEVANCEDETAILSBYID: 'msme/getgrievancedetailsbygrievanceidmsme',
    GETMSMECUSTOMFEEDBACKQUESTION: 'msme/getmsmecustomfeedbackquestion',
    GETIAREPOSITORYDETAILS: 'msme/getiarepositorydetails',
    POSTMSMECUSTOMFEEDBACK: 'msme/savecustomefeedback',
    GETMSMEPERSONALDETAILS: 'msme/getmsmepersonaldetails',
    GETAPPROVEREMARKS: 'msme/getmsmeremarksbyapprover',
    VALIDATEMSMEUSER: 'msme/validatemsmeuserbeforeenrollment',
    GETMSMEPARTICIPANTLIST: 'msme/getmsmeparticipantlist',
    GETMSMEPARTICIPANTCERTIFICATE: 'msme/msmecertificate',
    GETMSMECETIFICATE: 'msme/msmecertificate',
    GETMSMECETIFICATEDETAILS: 'msme/msmecertificatedetails',
    UPDATEINTERESTDETAILSONUDYAMPROFILE: 'msme/updateinterestdetailsonudyamprofile',
    GETPARTICPANTSFORFEEDBACK: 'msme/getparticipantsforfeedback',
    GET_LOCKED_INTERESTS: 'msme/locked-interests',

  },
  IA: {
    LOGIN: 'industryassociation/login',
    CHANGEPASSWORD: 'industryassociation/password/change',
    FORGOTPASSWORD: 'industryassociation/password/update',
    SAVEUSER: 'industryassociation/saveuser',
    GETUSERBYID: 'industryassociation/getuserbyid',
    GETCONTACTDETAILS: 'industryassociation/sendotp',
    IAORGANISATIONINFORMATION: 'industryassociation/saveiaorganisationalinfo',
    InsertUpdateProposal: 'Proposal/insertupdateproposalsubmission',
    //UpdateProposal: 'Proposal/updateproposalsubmission',
    GETDistrictHelp: 'Proposal/getdistrict',
    GETIAORGANISATIONINFORMATION: 'industryassociation/getiaorganisationalinfo',
    GETIAORGANISATIONINFORMATIONFORMSSIDC: 'industryassociation/getiaorganisationalinfoformssidc',
    UPDATEIAORGANISATIONINFORMATION: 'industryassociation/updateiaorganisationalinfo',
    GETIACREATEEVENT: 'industryassociation/getevents',
    GETCREATEEVENT: 'industryassociation/geteventsdata',
    GETIACOMPONENT: 'industryassociation/getcomponent',
    GETSPOCDETAILS: 'industryassociation/getspocdetails',
    GETIACITYTOWN: 'district/getcityblockonDistrict',
    POSTEVENTCREATION: 'industryassociation/saveeventdetails',
    GETPROPOSALLIST: 'Proposal/getproposaldetails',
    GETIAPROPOSALLIST: 'Proposal/getiaproposallist',
        GETIAPROPOSALLISTbyStatus: 'Proposal/getiaproposallistByStatus',
    CHECKEMAILEXIST: 'industryassociation/checkemailexistiniaregistration',
    CHECKMOBILEEXIST: 'industryassociation/checkmobilenumberexistiniaregistration',
    ONSPOTREGISTRATIONBYIA: 'industryassociation/onspotregistrationbyia',
    UPDATEONSPOTREGISTRATION: 'industryassociation/updateonspotregistrationbyia',
    UPDATEIAUSERPROFILE: 'industryassociation/updateiauserprofile',
    GETIAPROFILEQUESTIONS: 'industryassociation/getotherdetailsia',
    GETONSPOTREGISTRATIONRECORD: 'industryassociation/getonspotrecords',

    GETPROPOSALSUBMISSIONDETAILS: 'Proposal/getproposalsubmissiondetails',
    GETTARGETMSME: 'Proposal/gettargetmsme',
    GETIAEventDetail: 'industryassociation/getiadetailbyid',
    GETEventDetail: 'industryassociation/getdetailbyid',
    POSTIAEVENTUPDATE: 'industryassociation/updateiaevent',
    POSTIAEVENTUPDATEBYID: 'industryassociation/updateiaeventbyIA',





    SAVEIAEVENTATTENDANCE: 'industryassociation/saveiaeventattendance',
    GETOnSpotRegistrationByUserId: 'industryassociation/getonspotdetailsbyid',
    //POST

    POSTEVENTUPDATE: 'mssidc/updateiadetails',
    GETIAEVENTDATE: 'industryassociation/getiaeventdates',
    GETIAEVENTCALENDERDATELIST: 'industryassociation/getiacalenderdatelist',
    GETEVENTSPARTICIPANTSDETAILS: 'industryassociation/geteventparticipants',
    GETEVENTOUTPUTREPORT: 'industryassociation/getEventOutputReport',
    //GETIAGRIEVANCEDETAILS: 'industryassociation/getiagrievancedetails',
    //GETGRIEVANCEBYID: 'industryassociation/getgrievancedetailsbygrievanceidforia',
    //SAVEGRIEVANCEREPLYBYIA: 'industryassociation/insertiagrievancereply',
    POSTEVENTOUTPUTREPORT: 'industryassociation/saveEventOutputReport',
    //GETGRIEVANCEREPLYFORIA: 'industryassociation/getgrievancedetailsreplyforia',
    //GETGRIEVANCECOUNTFORDASHBOARD: 'industryassociation/getiagrievancecountfordashboard',
    IASAVEREPOSITORYCONTENT: 'industryassociation/iasaverepositorycontent',
    GETIACONTACTDETAILS: 'industryassociation/getiacontactdetails',
    GETIAREPOSITORYDETAILSBYIAUSERNAME: 'industryassociation/getiarepositorydetailsbyiausername',
    GETREPOSITORYDOCUMENTDETAILS: 'mssidc/getrepositorydocumentdetails',
    UPDATEREPOSITORYVISIBLITY: 'mssidc/updaterepositoryvisiblity',
    GETIAINTEREST: 'industryassociation/getiacomponent',
    GETIAREPOSITORYID: 'industryassociation/getrepositorydocumentbyid',
    GETTOTALMSMEREGISTERCOUNT: 'industryassociation/gettotalmsmeregistercount',
    GETTOTALONSPOTUSER: 'industryassociation/gettotalonspotrecords',
    GETONSPOTENROLLEDPARTICIPANTLIST: 'industryassociation/getenrolledonspotparticipantslist',
    GETEVENTIADOCUMENTS: 'industryassociation/geteventiadocuments',
    REMOVEDOCUMENT: 'industryassociation/removedocument',
    CHECKENROLLMENTINONSPOT: 'industryassociation/checkenrollmentinonspot',
    GETEVENTIAATTENDANCEWITHUDYAM: 'industryassociation/geteventiaattendance',
    GETSEATINGCAPACITY: 'industryassociation/getseatingcapacity',
    GETMSMEBYIAINTEREST: 'industryassociation/getregistermsmebyiainterest',
    GETATTENDEDMSMELISTFORIA: 'industryassociation/attendedmsmelistforia',
    UPDATEUNREGISTEREDMSME: 'industryassociation/updateunregisteredmsme',
    VALIDATEUNREGISTEREDMSME: 'industryassociation/validateunregisteredmsme',
    GETOTHERDETAILSIA: 'industryassociation/getotherdetailsia',
    GETENROLLEDMSMELISTFORIA: 'industryassociation/enrolledmsmelistforia',
    GETEVENTURL: 'industryassociation/geteventurl',
    UPDATELIVEEVENTURL: 'industryassociation/saveeventurl',
    GETFEEDBACKLIST: 'industryassociation/viewfeedback',
    SAVEIAQUESTIONANSWER: 'industryassociation/saveiaquestionanswer',
    GETEVENTATTENDANTLIST: 'industryassociation/geteventattendantlist',
    GETIAEVENTDOCUMENTSLIST: 'industryassociation/getiaeventdocumentslist', 
  },

  REVERSEBUYERSELLER: {
    GETBUYERSELLERMATCHES: 'industryassociation/getbuyersellermatches',
    SAVEBUYERREQUIREMENT: 'industryassociation/savereversebuyerrequirements',
    UPDATEBUYERREQUIREMENT: 'industryassociation/updatereversebuyerrequirements',
    DELETEBUYERREQUIREMENT: 'industryassociation/deletereversebuyerrequirements',
    GETBUYERREQUIREMENT: 'industryassociation/getbuyersellerrequirements',
   


  },



  MSSIDC: {
    LOGIN: 'mssidc/login',
    GETMSSIDCPROPOSALDETAILS: 'mssidc/getproposallist',
    GETVERIFYPROPOSALDETAILS: 'mssidc/getverifyproposaldetails',
    GETVERIFYPROPOSALBYMSSIDC: 'mssidc/getverifyproposalbymssidc',
    GETMSMEDetails: 'msme/getlist',
    GETMSMEIndividualDetails: 'msme/getdetails',
    POSTMSMEUpdate: 'msme/user/msmestatus',
    GETIAEventList: 'mssidc/getialist',
    GETIAEventDetail: 'mssidc/getiadetailbyid',
    POSTPROPOSALUPDATE: 'mssidc/user/proposalstatus',
    // POSTPROPOSALUPDATE: 'mssidc/proposalstatus',
    GETPROPOSALCOUNT: 'mssidc/getproposalsubmitcount',
    GETTARGETMSMEVALUE: 'mssidc/gettargetmsme',
    GetBalanceTargetMSSIDC: 'mssidc/getbalancetargetmssidc',
    GETWORKORDEREXTENSIONDETAILS: 'mssidc/getworkorderextensiondetails',
    POSTWORKORDEREXTENSION: 'mssidc/postworkorderextension',
getEventCapacityByEventId: 'mssidc/geteventcapacitybyeventid',
    getBannerList: 'mssidc/getbennerList',
insertUpdateBanner: 'mssidc/InsertUpdateBanner',
DELETEBANNER: 'mssidc/DeleteBanner',
    GETTOTALCOUNT: 'mssidc/gettotalcount',
    GETENROLLANDONSPORTMSMELIST:'mssidc/gettotalcount',
    GETDYNAMICDASHBOARDDATA: 'mssidc/getdynamicdashboarddata',
    GETINTERVENTIONSUMMARY: 'mssidc/getinterventionsummary',
    GETTOTALEVENTS: 'mssidc/gettotalEventlist',
    GETTOTALEVENTSSPOT: 'mssidc/gettotalEventlistSpot',
    //GETMSSIDCGRIEVANCEDETAILS: 'mssidc/getmssidcgrievancedetails',
    //GETGRIEVANCEDETAILSBYGRIEVANCEID: 'mssidc/getgrievancedetailsbygrievanceid',
    //SAVEMSSIDCGRIEVANCEREPLY: 'mssidc/insertmssidcgrievancereply',    
    GETIAPROFILEBYID: 'mssidc/getiaprofilebyid',
    //GETGRIEVANCEREPLYFORMSSIDC : 'mssidc/getgrievancedetailsreplyformssidc',
    GETINTERVENTION: 'mssidc/getintervention',
    GETINTEREST: 'mssidc/getcomponent',
    GETGRADING: 'mssidc/getgrading',
    POSTCUSTOMFEEDBACK: 'mssidc/customfeedback',
    GETCUSTOMFEEDBACK: 'mssidc/getcustomfeedbacklist',
    GETCUSTOMINDQUESTION: 'mssidc/getcustomquestion',
    GETCUSTOMQUESTIONCREATE: 'mssidc/getcustomquestioncreate',
    GETCUSTOMQUESTIONCREATED: 'mssidc/getcustomquestionintercomp',
    POSTCUSTOMFEEDBACKINTERCOPM: 'mssidc/postcustomfeedbackintercopm',
    GETREPOSITORYDETAILS: 'mssidc/getrepodetailsbymssidc',
    GETIADOCUMENTS: 'mssidc/getIADocument',
    GETFUNDAMOUNTDETAILS: 'mssidc/getfundamountdetails',
    CHANGEPASSWORD: 'mssidc/password/change',
    GETUSERMASTER: 'mssidc/getusermasterlist',
    INSERTINTOUSERMASTER: 'mssidc/insertnewmusermaster',
    UPDATEDINUSERMASTER: 'mssidc/updateinmusermaster',
    DELETEFROMUSERMASTER: 'mssidc/deletefromusermaster',
    GETMDList: 'mssidc/getmddetails',
    POSTMDDETAILS: 'mssidc/savemddetails',
    POSTMDSTATUS: 'mssidc/updatemdstatus',
    GETEVENTLIST: 'mssidc/getgradingevent',

    
    GETFEEDBACKLIST: 'mssidc/getGradingMSMEFeeback',
    GETENROLLEDMSMELISTFORMSSIDC: 'mssidc/enrolledmsmelistformssidc',
    //GETENROLLEDMSMELISTFORMSSIDC: 'mssidc/getinvoicedetails',
    GETATTENDEDMSMELISTFORMSSIDC: 'mssidc/attendedmsmelistformssidc',
    //GETCOMPOMENTS:'mssidc/getcomponents'
    RESETUSERMASTERPASSWORD: 'mssidc/resetmusermasterpassword',
    POSTEVENTINSERTION: 'mssidc/inserteventdetails',
    GETIALISTFORDASHBOARD: 'mssidc/getialistforDashboard',
    INSERTSPORTMSME: 'mssidc/insertsportMsme',
    UPLORDEXCELS: 'mssidc/uploadExcel',
    GET_SPORT_ATTENDANCE_FILES: 'mssidc/getSportAttendanceFiles',
    GET_SPORT_ATTENDANCE_FILES_velidMSMEList: 'mssidc/getSportAttendanceFilesvelidMSMEList',
   GET_SPORT_ATTENDANCE_FILES_NOtvelidMSMEList:'mssidc/getSportAttendanceFilesNOTvelidMSMEList',
    UPDATEEVENTDATE:'mssidc/UpdateEventDate',
   GETTOTALEVENTSDATELIST:'mssidc/getEventDateList',
      GETEVENTSATTENDANCE:'mssidc/getEventAttendance',
   GETTOTALEVENTSDATELISTbYUNIQUEEVENTID:'mssidc/getEventDateListbyUniqueEventId',

   SAVE_MSSIDC_EVENT_ATTENDANCE:'mssidc/savemssidceventattendance',
getmsmelistforattendance: 'mssidc/getmsmelistforattendance',
checkMsmeInterestIntervention: 'mssidc/checkMsmeInterestIntervention',
checkCapacityBuildingEligibility: 'mssidc/checkCapacityBuildingEligibility',
  },
  DIC: {
    LOGIN: 'mssidc/login',
    UPLOADMONITORFILEDIC: 'dic/uploadMonitorFileDIC',
    CHANGEPASSWORD: 'dic/password/change'
  },
  EOI: {
    EOI: 'eoi/submitEoi',
    EOISendOTP: 'eoi/sendotp',
    GETEoi: 'eoi/getexpressionofinterest',
    GETResEoi: 'eoi/getresponseofinterest',
    SAVEGENERATEDFORM: 'eoi/savegeneratedform',
  },




  register: '',
  LOGIN:
  {
    MSME: 'msme/login',
    IA: 'industryassociation/login',
    MSSIDC: 'mssidc/login',
    DIC: 'mssidc/login',
    MSMESSO: 'sso/msme-sso'
  },
  CHANGEPASSWORD: {
    MSME: 'msme/login',
    IA: ''
  },
  FORGOTPASSWORD: {
    MSME: 'msme/password/update',
    IA: 'industryassociation/password/update'
  },
  Otp: {
    SendOtp: 'notification/sendOtp',
    VerifyOtp: 'notification/verifyOtp',
    IAVerifyOtp: 'industryassociation/verifyotp',
    MSMEVerifyOtp: 'msme/verifyotp',
    SendMobileEmailOtp: 'notification/mobileemailotp',
  },
  INTEREST: {
    GETINTEREST: 'interest/getlist',
    SAVEINTEREST: 'interest/save'
  },
  FOCUSSECTOR: {
    GETFOCUSSECTOR: 'focussector/getlist',
  },

  MASTERS: {

    USERTYPE: {
      GETLIST: 'users/getlist',
      SAVE: 'users/save',
      UPDATE: 'users/update',
      DELETE: 'users/delete',
      GETDETAILS: 'users/getusertypedetails'
    },

    EVENTCAPACITY: {
      GETLIST: 'eventcapacity/getlist',
      SAVE: 'eventcapacity/save',
      UPDATE: 'eventcapacity/update',
      DELETE: 'eventcapacity/delete',
      GETDETAILS: 'eventcapacity/geteventcapacitydetails',
      GETHISTORY: 'eventcapacity/geteventcapacityhistory',
    },

    INTEREST: {
      GETLIST: 'interest/getlist',
      SAVE: 'interest/save',
      UPDATE: 'interest/update',
      DELETE: 'interest/delete',
      GETDETAILS: 'interest/getinterestdetails'
    },
    INTERVENTION: {
      GETLIST: 'intervention/getlist',
      SAVE: 'intervention/save',
      UPDATE: 'intervention/update',
      DELETE: 'intervention/delete',
      GETDETAILS: 'intervention/getinterventiondetails'
    },
    BLOCK: {
      GETLIST: 'block/getlist',
      SAVE: 'block/save',
      UPDATE: 'block/update',
      DELETE: 'block/delete',
      GETBLOCKBASEDONDISTRCIT: 'block/getblockbasedondistrict',
      GETDETAILS: 'block/getblockdetails'
    },

    SOCIALCATEGORY: {
      GETLIST: 'socialcategory/getlist',
      SAVE: 'socialcategory/save',
      UPDATE: 'socialcategory/update',
      DELETE: 'socialcategory/delete',
      GETDETAILS: 'socialcategory/getsocialcategorydetails'
    },
    DISTRICT: {
      GETLIST: 'district/getlist',
      SAVE: 'district/save',
      UPDATE: 'district/update',
      DELETE: 'district/delete',
      GetPagination: 'district/getDistrictDetails',
      GETDISTRICTBASEDONSTATE: 'district/getdistrictbasedonstate',
      GETCITYANDBLOCKONNDISTRICT: 'district/getcityblockonDistrict',
      GETCITYBLOCK: 'district/getcityblock'
    },
    STATE: {
      GETLIST: 'state/getstates',
      SAVE: 'state/save',
      UPDATE: 'state/update',
      DELETE: 'state/delete',
      GetPagination: 'state/getstateDetails'
    },
    GREENTECHNOLOGY: {
      GETLIST: 'greentechnology/getlist',
      SAVE: 'greentechnology/save',
      UPDATE: 'greentechnology/update',
      DELETE: 'greentechnology/delete',
      GETDETAILS: 'greentechnology/getgreentechnologydetails'
    },
    CiTY:
    {
      GETLIST: 'city/getlist',
      SAVE: 'city/save',
      UPDATE: 'city/update',
      DELETE: 'city/delete',
      GetPagination: 'city/getcitydetails'

    },
    Fund:
    {
      GET_interventionDetails_help: 'FundManagement/getinterventiondetails',
      GET_componentDetails_help: 'FundManagement/getcomponentdetails',
      GET_intervention_help: 'Proposal/getintervention',
      GET_iaprofiledetails_help: 'Proposal/getIAProfile',
      GET_component_help: 'Proposal/getcomponent',
      //GET_intervention_help: 'FundManagement/getintervention',
      //GET_component_help: 'FundManagement/getcomponent',
      //GET_componentDetails_Help: 'FundManagement/getcomponentdetails',
      GETLIST: 'FundManagement/getbudgetdetails',
      SAVE: 'FundManagement/savebudgetdetails',
      Delete: 'FundManagement/DeleteBudgetDetails',
    },
    FOCUSSECTOR:
    {
      GETLIST: 'focussector/getlist',
      SAVE: 'focussector/save',
      UPDATE: 'focussector/update',
      DELETE: 'focussector/delete',
      GETDETAILS: 'focussector/getfocussectordetails'
    },

    ENTERPRISE:
    {
      GETLIST: 'TypeEnterprise/getlist',
      SAVE: 'TypeEnterprise/save',
      UPDATE: 'TypeEnterprise/update',
      DELETE: 'TypeEnterprise/delete',
      GETDETAILS: 'TypeEnterprise/getenterprisedetails'

    },
    NIC: {
      GETNICLIST: 'nic/getniclist',
      GETSECTORBASEDONNIC: 'nic/getsectorbasedonniccode',
      GETNICDATAFORPDF: 'nic/getnicdataforpdf'
    },
    CERTIFICATE:
    {
      GETLIST: 'ISOCertificate/getlist',
      SAVE: 'ISOCertificate/save',
      UPDATE: 'ISOCertificate/update',
      DELETE: 'ISOCertificate/delete',
      GETDETAILS: 'ISOCertificate/getdetails'
    },
    ORGANIZATIONTYPE:
    {
      GETLIST: 'OrganizationType/getlist',
      SAVE: 'OrganizationType/save',
      UPDATE: 'OrganizationType/update',
      DELETE: 'OrganizationType/delete',
      GETDETAILS: 'OrganizationType/getdetails'
    },
    GRIEVANCE: {
      GETGRIEVANCELIST: 'grievance/getgrievancelist',
      ADDGRIEVANCE: 'grievance/savegrievance',
      UPDATEGRIEVANCE: 'grievance/updategrievance',
      DELETEGRIEVANCE: 'grievance/deletegrievance',
      GETPAGINATEDGRIEVANCE: 'grievance/getgrievancedetails',
      GETGRIEVANCESTATUS: 'grievance/getgrievancestatus',

      GETIAGRIEVANCEDETAILS: 'grievance/getiagrievancedetails',
      GETGRIEVANCEBYID: 'grievance/getgrievancedetailsbygrievanceidforia',
      SAVEGRIEVANCEREPLYBYIA: 'grievance/insertiagrievancereply',
      GETGRIEVANCESTATUSFORIA: 'grievance/getgrievancestatusforia',
      GETGRIEVANCEREPLYFORIA: 'grievance/getgrievancedetailsreplyforia',
      GETGRIEVANCECOUNTFORDASHBOARD: 'grievance/getiagrievancecountfordashboard',


      MSMESUBMITGRIEVANCE: 'grievance/msmesubmitgrievance',
      GETSUBMITTEDMSMEGRIEVANCEDETAILS: 'grievance/getmsmegrievancesubmiteddetails',
      GETGRIEVANCEREPLY: 'grievance/getgrievancedetailsreplyformsme',
      GETGRIEVANCEDETAILSBYID: 'grievance/getgrievancedetailsbygrievanceidmsme',


      GETMSSIDCGRIEVANCEDETAILS: 'grievance/getmssidcgrievancedetails',
      GETGRIEVANCEDETAILSBYGRIEVANCEID: 'grievance/getgrievancedetailsbygrievanceid',
      SAVEMSSIDCGRIEVANCEREPLY: 'grievance/insertmssidcgrievancereply',
      GETGRIEVANCEREPLYFORMSSIDC: 'grievance/getgrievancedetailsreplyformssidc',


    },
    INVOICE: {
      GETEVENTDETAILSBYIAID: 'invoice/geteventdetailsbyiaid',
      GETINVOICESTATUSMASTER: 'invoice/getstatusmaster',
      GETEVENTDETAILSFORMSSIDC: 'invoice/geteventdetailsformssidc',
      GETEVENTLISTFORMSSIDC: 'invoice/geteventlistformssidc',
      GETEVENTLISTBYIAID: 'invoice/geteventlistbyiaid',
      INSERTINVOIDEDETAILSBYIA: 'invoice/insertinvoicedetailsbyia',
      INSERTPAYMENTDETAILSBYMSSIDC: 'invoice/insertpaymentdetailsbymssidc',
      CHECKIFINVOICESUBMITTEDFOREVENTID: 'invoice/checkifinvoicesubmittedforeventid',
      GETINVOICESTATUSDATA: 'invoice/getinvoicestatusdata',
      GETINVOICESTATUSDATAFORMSSIDC: 'invoice/getinvoicestatusdataformssidc',
      UPDATEINVOICEACCEPTANCESTATUS: 'invoice/updateinvoiceacceptance',
      CHECKPAYMENTSTATUS: 'invoice/checkpaymentstatus',
      GETPAYMENTDETAILS: 'invoice/getpaymentdetails',
      GETPAYMENTMODE: 'invoice/getpaymentmode',
      GETMSMELISTFORIA: 'invoice/getverifiedunverifiedmsmelist',
      EXPORTTOEXCELADDEDDCOLUMNS: 'invoice/ExportVerifiedUnverifiedMSMEList',
      GETCOMPLETEDINVOICElIST: 'invoice/getcompletedinvoicelist',
      UPDATEPAYMENTSTATUSBYMSSIDC: 'invoice/updatepaymentstatusbymssidc',
      GETINVOICEDOCUMENTDETAILS: 'invoice/getinvoicedetails',
      VERIFYMSMEELIGIBILITY: 'invoice/verifyMSMEEligibility',
      GETMSMELISTFORIAA: 'invoice/verifyMSMEEligibility',
      GETVIEWINVOICECALCULATIONDATA: 'invoice/getinvoicecalculationdata'
    }
  },

  REPORT: {
    MSSIDCUSERLIST: 'report/mssidcuserlist',
    REGISTERDIALIST: 'report/allregisteredialist',
    REGISTERDMSMELIST: 'report/allregisteredmsmelist',
    TOTALEVENTLIST: 'report/alltotaleventlist',
    COMPLETEDEVENTLIST: 'report/allcompletedeventlist',
    SCHEDULEDEVENTLIST: 'report/allscheduledeventlist',
    CANCELPOSTPONEEVENTLIST: 'report/allcancelpostponeevent',
    TOTALPROPOSALLIST: 'report/alltotalproposallist',
    DISTRICTWISETRAINING: 'report/districtwisetraining',
    DISTRICTCATEGORYWISETRAINING: 'report/districtcategorywisetraining',
    IABANKDETAILS: 'report/iabankdetails',
    PARTICIPANTDETAILS: 'report/participantdetails',
    PROPOSALWISETARGETMSME: 'report/proposalwisetargetmsme',
    EVENTREPORTFORAPPROVEDWORKORDER: 'report/eventreportapprovedworkorder',
    MSMEDETAILSEVENTWISE: 'report/msmereporteventwise',
  },

  UDYAM: {
    VERIFYUDYAM: 'udyamauth/verifyudyam'
  },

  headers: {
    Authorization: `Bearer ${localStorage.getItem('authToken')}`
  },

  masterusertypesave: 'users/save',
  masterusertypeupdate: 'users/update',
  masterusertypedelete: 'users/delete',

  masterinterestgetlist: 'interest/getlist',
  masterinterestsave: 'interest/save',
  masterinterestupdate: 'interest/update',
  masterinterestdelete: 'interest/delete',

  masterinterventiongetlist: 'intervention/getlist',
  masterinterventionsave: 'intervention/save',
  masterinterventionupdate: 'intervention/update',
  masterinterventiondelete: 'intervention/delete',

  masterblockgetlist: 'block/getlist',
  masterblocksave: 'block/save',
  masterblockupdate: 'block/update',
  masterblockdelete: 'block/delete',

  masterdistrictgetlist: 'district/getlist',
  masterdistrictsave: 'district/save',
  masterdistrictupdate: 'district/update',
  masterdistrictdelete: 'district/delete',

  masterstategetstates: 'state/getstates',
  masterstatesave: 'state/save',
  masterstateupdate: 'state/update',
  masterstatedelete: 'state/delete',

  mastercitygetlist: 'city/getlist',
  mastercitysave: 'city/save',
  mastercityupdate: 'city/update',
  mastercitydelete: 'city/delete',

  getfeedbackquestions: 'feedback/getMsmefeedbackquestions',
  geteventdetailsforfeedbackform: 'feedback/geteventdetailsforfeedbackform',
  savemsmefeedbackquestionanswer: 'feedback/savemsmefeedbackquestionanswer',

  ValidateUser: 'msme/validateuser',
  SINGUP: 'users/signup',
  resetPassword: 'users/resetPassword/',
  forgetPassword: 'users/forgotPassword',
  getBrowserDetail: 'users/getBrowserDetail/',
  setBrowserDetail: 'users/setBrowserDetail',
  users: 'users',
  deleteUser: 'users/deleteUser/',
  editUser: 'users/updateUser',
  createUser: 'users/createUser',
  getRoles: 'roles',
  getPermissions: 'permissions',
  getAllPermissionsByRole: 'permissions/getAllPermissionsByRole',
  getAllPermissionsByCompany: 'permissions/getAllPermissionsByCompany/',
  getPermissionByID: 'permissions/',
  createPermissions: 'permissions/createPermission',
  assignPermissions: 'permissions/assignPermission',
  assignCompanyPermission: 'permissions/assignCompanyPermission',
  updatePermissions: 'permissions/updatePermission',
  deletePermissions: 'permissions/deletePermission/',
  unAssignPermission: 'permissions/unAssignPermission/',
  getRoleByID: 'roles/',
  createRoles: 'roles/createRole',
  updateRoles: 'roles/updateRole',
  deleteRoles: 'roles/deleteRole/',
  getAllCountriesList: 'countries',
  getCountryById: 'countries/',
  createCountry: 'countries/createCountry',
  updateCountry: 'countries/updateCountry',
  deleteCountry: 'countries/deleteCountry/',
  getAllCompaniesList: 'companies',
  getAllCompaniesListByCountry: 'companies/getAllCompaniesByCountry/',
  getCompanyById: 'companies/',
  createCompany: 'companies/createCompany',
  updateCompany: 'companies/updateCompany',
  deleteCompany: 'companies/deleteCompany/',
  getAllBranchesList: 'branches',
  getAllBranchesListByCompany: 'branches/getAllBranchesByCompany/',
  getBranchById: 'branches/',
  createBranch: 'branches/createBranch',
  updateBranch: 'branches/updateBranch',
  deleteBranch: 'branches/deleteBranch/',
  categories: 'categories',
  getCategoryById: 'categories/',
  getNestedCategories: 'categories/nest',
  getAllCategoriesByCountry: 'categories/getAllCategoriesByCountry/',
  getAllCategoriesByCompany: 'categories/getAllCategoriesByCompany/',
  createCategory: 'categories/createCategory',
  editCategory: 'categories/updateCategory',
  deleteCategory: 'categories/deleteCategory/',
  units: 'units',
  getUnitById: 'units/',
  getAllUnitsByCountry: 'units/getAllUnitsByCountry/',
  getAllUnitsByCompany: 'units/getAllUnitsByCompany/',
  createUnit: 'units/createUnit',
  editUnit: 'units/updateUnit',
  deleteUnit: 'units/deleteUnit/',
  manufacturers: 'manufacturers',
  getManufacturerById: 'manufacturers/',
  getAllManufacturersByCountry: 'manufacturers/getAllManufacturersByCountry/',
  getAllManufacturersByCompany: 'manufacturers/getAllManufacturersByCompany/',
  createManufacturer: 'manufacturers/createManufacturer',
  editManufacturer: 'manufacturers/updateManufacturer',
  deleteManufacturer: 'manufacturers/deleteManufacturer/',
  taxClasses: 'taxClasses',
  getTaxClassById: 'taxClasses/',
  getAllTaxClassesByCountry: 'taxClasses/getAllTaxClassesByCountry/',
  getAllTaxClassesByCompany: 'taxClasses/getAllTaxClassesByCompany/',
  createTaxClass: 'taxClasses/createTaxClass',
  editTaxClass: 'taxClasses/updateTaxClass',
  deleteTaxClass: 'taxClasses/deleteTaxClass/',
  taxRates: 'taxRates',
  getTaxRateById: 'taxRates/',
  getAllTaxRatesByCountry: 'taxRates/getAllTaxRatesByCountry/',
  getAllTaxRatesByCompany: 'taxRates/getAllTaxRatesByCompany/',
  createTaxRate: 'taxRates/createTaxRate',
  editTaxRate: 'taxRates/updateTaxRate',
  deleteTaxRate: 'taxRates/deleteTaxRate/',
  productOptions: 'productOptions',
  getProductOptionById: 'productOptions/',
  getAllProductOptionsByCountry: 'productOptions/getAllProductOptionsByCountry/',
  getAllProductOptionsByCompany: 'productOptions/getAllProductOptionsByCompany/',
  createProductOption: 'productOptions/createProductOption',
  editProductOption: 'productOptions/updateProductOption',
  deleteProductOption: 'productOptions/deleteProductOption/',
  productOptionValues: 'productOptionValues',
  getProductOptionValuesById: 'productOptionValues/',
  getAllProductOptionValuesByCountry: 'productOptionValues/getAllProductOptionValuesByCountry/',
  getAllProductOptionValuesByCompany: 'productOptionValues/getAllProductOptionValuesByCompany/',
  createProductOptionValue: 'productOptionValues/createProductOptionValue',
  editProductOptionValue: 'productOptionValues/updateProductOptionValue',
  deleteProductOptionValue: 'productOptionValues/deleteProductOptionValue/',
  products: 'products',
  getProductById: 'products/',
  getAllProductsByCountry: 'products/getAllProductsByCountry/',
  getAllProductsByCompany: 'products/getAllProductsByCompany/',
  createProduct: 'products/createProduct',
  editProduct: 'products/updateProduct',
  updateProductImages: 'products/updateProductImages',
  updateProductInfo: 'products/updateProductInfo',
  deleteProduct: 'products/deleteProduct/',
  deleteProductImage: 'products/deleteProductImage/',
  createInventory: 'products/createInventory',
  banners: 'banners',
  getBannerById: 'banners/',
  getAllBannersByCompany: 'banners/getAllBannersByCompany/',
  createBanner: 'banners/createBanner',
  editBanner: 'banners/updateBanner',
  deleteBanner: 'banners/deleteBanner/',
  landingPageCategories: 'landingPageCategories',
  getLandingPageCategoryById: 'landingPageCategories/',
  getAllLandingPageCategoriesByCompany: 'landingPageCategories/getAllLandingPageCategoriesByCompany/',
  createLandingPageCategory: 'landingPageCategories/createLandingPageCategory',
  editLandingPageCategory: 'landingPageCategories/updateLandingPageCategory',
  deleteLandingPageCategory: 'landingPageCategories/deleteLandingPageCategory/',
  brands: 'brands',
  getBrandById: 'brands/',
  getAllBrandsByCompany: 'brands/getAllBrandsByCompany/',
  createBrand: 'brands/createBrand',
  editBrand: 'brands/updateBrand',
  deleteBrand: 'brands/deleteBrand/',
  generalSettings: 'generalSettings',
  getGeneralSettingById: 'generalSettings/',
  getAllGeneralSettingsByCompany: 'generalSettings/getAllGeneralSettingsByCompany/',
  createGeneralSetting: 'generalSettings/createGeneralSetting',
  editGeneralSetting: 'generalSettings/updateGeneralSetting',
  deleteGeneralSetting: 'generalSettings/deleteGeneralSetting/',
  orders: 'orders',
  getOrderById: 'orders/',
  getAllOrdersByCountry: 'orders/getAllOrdersByCountry/',
  getAllOrdersByCompany: 'orders/getAllOrdersByCompany/',
  createOrder: 'orders/createOrder',
  editOrder: 'orders/updateOrder',
  deleteOrder: 'orders/deleteOrder/',
  addauther: 'auther/createauther',
  addcategory: 'category/createcategory',
  getautherlist: 'auther/getallauther',
  getcategorylist: 'category/getallcategory',
  updateauther: 'auther/updateauther', 
  getauther: 'auther/getauther',
  getcategory: 'category/getcategory',
  getallbooks: 'book/GetAllBook',
  updatecategory: 'category/updatecategory',
  getbook: 'book/GetBook',
  validationsession: 'industryassociation/validate-session',
  getdistrictlistbystate: 'eoiexhibition/getdistrictlist',
  getSocialCategory:'eoiexhibition/getsocialcategorylist',
  getOrganizationType: 'eoiexhibition/getorganizationtypelist',
  getEoiExhibitionList: "eoiexhibition/geteoiexhibitionlist",
  getEoiExhibitionView: "eoiexhibition/geteoiexhibitionview",
  getEoiExhibitionDownloadAllDocuments: "eoiexhibition/EoiExhibitionDownloadZip",
}


